import { type ReactElement } from 'react'
import { Overlay } from '@mantine/core'

type MobileNavBackdropProps = {
  onClose: VoidFunction
}

const BACKDROP_Z_INDEX = 'calc(var(--mantine-z-index-app) - 1)'

export const MobileNavBackdrop = ({ onClose }: MobileNavBackdropProps): ReactElement => {
  return (
    <Overlay
      aria-hidden
      backgroundOpacity={0.45}
      color='var(--mantine-color-dark-9)'
      fixed
      hiddenFrom='sm'
      tabIndex={-1}
      zIndex={BACKDROP_Z_INDEX}
      onClick={onClose}
    />
  )
}
